import Loading from './icons/Loading'
import Burger from './icons/Burger'
import Gear from './icons/Gear'

export default {
  loading: Loading,
  burger: Burger,
  gear: Gear
}
